import { render } from "./PixelWorld.vue?vue&type=template&id=3ba9a71f&scoped=true"
import script from "./PixelWorld.vue?vue&type=script&lang=js"
export * from "./PixelWorld.vue?vue&type=script&lang=js"

import "./PixelWorld.vue?vue&type=style&index=0&id=3ba9a71f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba9a71f"]])

export default __exports__